import {
  GET_AGENCY_REFERRED_USERS_REQUEST,
  GET_AGENCY_REFERRED_USERS_SUCCESS,
  GET_AGENCY_REFERRED_USERS_FAILURE,
} from '../actions/agencyActions';

const initialState = {
  loading: false,
  list: [],
  error: null,
  pagination: {
    totalCount: 0,
    page: 1,
    limit: 50,
  },
};

export default function agency(state = initialState, action) {
  switch (action.type) {
    case GET_AGENCY_REFERRED_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_AGENCY_REFERRED_USERS_SUCCESS: {
      const payload = action.payload || {};
      const dataList = Array.isArray(payload)
        ? payload
        : (payload.data && Array.isArray(payload.data))
          ? payload.data
          : (payload.list && Array.isArray(payload.list))
            ? payload.list
            : [];

      const totalCount = payload.totalCount || payload.total || payload.count || dataList.length || 0;
      const page = payload.page || state.pagination.page;
      const limit = payload.limit || state.pagination.limit;

      return {
        ...state,
        loading: false,
        list: dataList,
        pagination: {
          totalCount,
          page,
          limit,
        },
      };
    }
    case GET_AGENCY_REFERRED_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || 'Failed to fetch referred users',
      };
    default:
      return state;
  }
}


